<template>
	<v-card>
		<v-card-title class="font-weight-bold" :style="`color:${scdColorDarkBlue}`">
			Gestione Screenshot ed Esiti {{ nomeBando }}
		</v-card-title>
		<v-card-text class="font-weight-medium" style="font-size: 16px">
			<v-row>
				<v-col cols="2">
					<v-btn
						color="secondary"
						rounded
						dark
						:loading="isLoadingIscritti"
						@click="getIscritti(idSquadraSelezionata)"
					>
						<v-icon>mdi-reload</v-icon>
					</v-btn>
				</v-col>
				<v-col
					v-if="computedAmIAdmin || computedAmIDeveloper"
					cols="4">
					<v-select
						class="pt-0"
						item-text="nome"
						item-value="id"
						:items="squadre"
						v-model="idSquadraSelezionata"
						placeholder="Seleziona"
						:loading="isLoadingSquadre"
						:disabled="isLoadingIscritti"
						clearable
						@change="getIscritti(idSquadraSelezionata)"
						@click:clear="idSquadraSelezionata = null; getIscritti()"
						hide-details
						outlined
						dense
					></v-select>
				</v-col>
				<v-col>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
							<tr>
								<th class="text-left">
									Iscritti
								</th>
								<th class="text-left">
									Screenshots caricati
								</th>
								<th class="text-left">
									Ricevute caricate
								</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="font-weight-medium">
									<v-progress-circular
										v-if="isLoadingIscritti"
										size="12"
										width="2"
										indeterminate
										:color="scdColor"
									></v-progress-circular>
									<template v-else>
										{{ totaleIscritti }}
									</template>
								</td>
								<td class="font-weight-medium">
									<v-progress-circular
										v-if="isLoadingIscritti"
										size="12"
										width="2"
										indeterminate
										:color="scdColor"
									></v-progress-circular>
									<template>
										{{ totaleScreenshotsCaricati }}
									</template>
								</td>
								<td class="font-weight-medium">
									<v-progress-circular
										v-if="isLoadingIscritti"
										size="12"
										width="2"
										indeterminate
										:color="scdColor"
									></v-progress-circular>
									<template>
										{{ totaleRicevuteCaricate }}
									</template>
								</td>
							</tr>
							
							</tbody>
						</template>
					</v-simple-table>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-data-table
						:headers="headersGestioneScreenshotsEdEsiti"
						:items="cliccatoriIscritti"
						loading-text="In caricamento.."
						:loading="isLoadingIscritti"
						no-data-text="Nessun cliccatore"
						:footer-props="{
							'items-per-page-options':[50, 100, 200, 500, -1],
							'items-per-page-text': 'Cliccatori per pagina'
						}"
						sort-by="codice_cliccatore"
						style="background-color: white; border-radius: 0"
						class="gestione-screenshots-ed-esiti-game-day-data-table"
						dense
						:options="{
							itemsPerPage: -1,
						}"
						fixed-header
						height="calc(100vh - 410px)"
					>
						<!--<template v-slot:item.stato_screenshot="{ item }">-->
						<!--	<template v-if="item.pratica_cdm">-->
						<!--		<v-radio-group-->
						<!--			v-model="item.pivot.stato_screenshot"-->
						<!--			@change="salvaStatoScreenshot(item)"-->
						<!--			:disabled="item.isSavingStatoScreenshot"-->
						<!--			class="my-1 pt-0"-->
						<!--			hide-details-->
						<!--			row-->
						<!--		>-->
						<!--			<v-radio-->
						<!--				v-for="(stato, index) in statiScreenshot"-->
						<!--				:key="index"-->
						<!--				:label="stato"-->
						<!--				:value="stato"-->
						<!--				:color="scdColor"-->
						<!--			></v-radio>-->
						<!--		</v-radio-group>-->
						<!--	</template>-->
						<!--	<template v-else>-->
						<!--		NESSUNA PRATICA ASSEGNATA-->
						<!--	</template>-->
						<!--</template>-->
						<template v-slot:item.gestione_screenshot="{ item }">
							<template v-if="item.pratica_cdm">
								<div class="d-flex align-center">
									<!-- 1. Button that will be clicked to select a file -->
									<v-btn
										color="primary"
										rounded
										dark
										small
										class="mr-2"
										:loading="item.isSelectingScreenshot || item.isUploadingScreenshot"
										@click="handleFileScreenshotImport(item)"
									>
										Carica
									</v-btn>
									<!-- File Input that will be hidden but triggered with JavaScript -->
									<input
										:ref="`screenshotUploader${item.id}`"
										class="d-none"
										type="file"
										accept="image/*"
										@change="onFileScreenshotChanged($event, item)"
									>
									
									<v-btn
										color="primary"
										rounded
										small
										:disabled="item.pratica_cdm.path_screenshot_invio === null || item.isUploadingScreenshot"
										@click="apriAnteprimaScreenshotDialog(item)"
									>
										Visualizza
									</v-btn>
								</div>
							</template>
							<template v-else>
								NESSUNA PRATICA ASSEGNATA
							</template>
						</template>
						
						<template v-slot:item.gestione_ricevuta="{ item }">
							<template v-if="item.pratica_cdm">
								<div class="d-flex align-center">
									<!-- 1. Button that will be clicked to select a file -->
									<v-btn
										color="#9001b1"
										rounded
										dark
										small
										class="mr-2"
										:loading="item.isSelectingRicevuta || item.isUploadingRicevuta"
										@click="handleFileRicevutaImport(item)"
									>
										Carica
									</v-btn>
									<!-- File Input that will be hidden but triggered with JavaScript -->
									<input
										:ref="`ricevutaUploader${item.id}`"
										class="d-none"
										type="file"
										accept="application/pdf"
										@change="onFileRicevutaChanged($event, item)"
									>
									
									<v-btn
										color="#9001b1"
										rounded
										small
										class="white--text"
										:disabled="item.pratica_cdm.path_ricevuta === null || item.isUploadingRicevuta"
										:loading="item.isGettingRicevuta"
										@click="apriRicevutaInUnaNuovaSchedaDelBrowser(item)"
									>
										Visualizza
									</v-btn>
								</div>
							</template>
							<template v-else>
								NESSUNA PRATICA ASSEGNATA
							</template>
						</template>
						
						<template v-slot:item.pivot.esito_clickday="{ item }">
							<span>{{ item.pivot.esito_clickday }}</span>
							<v-icon
								:color="scdColor"
								small
								@click="apriDialogEsitoClickday(item)"
							>
								edit
							</v-icon>
						</template>
						
						<template v-slot:item.team.nome="{ item }">
							<span v-if="item.team">{{ item.team.nome }}</span>
							<span v-else>Senza Squadra</span>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				rounded
				depressed
				style="text-transform:none; color:white;"
				@click="$emit('close')"
				:color="scdColor"
			>
				Chiudi
			</v-btn>
		</v-card-actions>
		
		<v-dialog
			v-model="previewScreenshotDialog"
			persistent
			scrollable
		>
			<v-card>
				<v-card-title
					class="font-weight-bold"
					:style="`color:${scdColorDarkBlue}`"
				>
					<v-row>
						<v-col>
							{{ previewScreenshotTitle }}
						</v-col>
						<v-col cols="3" style="display: flex; justify-content: end;">
							<v-switch
								v-model="zoomEnabled"
								:disabled="isLoadingBase64Screenshot"
								inset
								color="#7cc35d"
								label="Zoom"
								style="margin-top: 5px"
							></v-switch>
						</v-col>
						<v-col cols="2" class="flex align-center">
							<v-select
								:items="zoomScales"
								v-model="selectedZoomScale"
								:disabled="isLoadingBase64Screenshot"
								hide-details
								outlined
								dense
							></v-select>
						</v-col>
					</v-row>
				</v-card-title>
				<v-card-text
					class="font-weight-medium"
					style="font-size: 16px"
				>
					<v-progress-linear
						v-if="isLoadingBase64Screenshot"
						indeterminate
					></v-progress-linear>
					<v-img
						v-else-if="!zoomEnabled"
						:src="base64Screenshot"
						contain
					></v-img>
					<zoom-on-hover
						v-else-if="zoomEnabled"
						:key="zoomOnHoverKey"
						:img-normal="base64Screenshot"
						:img-zoom="base64Screenshot"
						:scale="selectedZoomScale"
					></zoom-on-hover>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="previewScreenshotDialog = false"
						:color="scdColor"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="mostraDialogModificaEsitoClickday"
			:key="dialogModificaEsitoClickdayKey"
			max-width="580"
			persistent
		>
			<modifica-esito-clickday-component
				:dati-esito-clickday="datiModificaEsitoClickday"
				:id-bando="idBando"
				@dati-esito-clickday-aggiornati="getIscritti(idSquadraSelezionata)"
				@chiudi-dialog="mostraDialogModificaEsitoClickday = false"
			></modifica-esito-clickday-component>
		</v-dialog>
	</v-card>
</template>

<script>
import mixin from '../../mixins';

export default {
	props: ['idBando', 'nomeBando'],
	data() {
		return {
			// GESTIONE SCREENSHOTS ED ESITI
			isLoadingSquadre: null,
			squadre: [],
			idSquadraSelezionata: null,
			
			// class: (this.computedAmIDeveloper || this.computedAmIAdmin) ? '' : 'd-none',
			// cellClass: (this.computedAmIDeveloper || this.computedAmIAdmin) ? '' : 'd-none'
			
			isLoadingIscritti: false,
			headersGestioneScreenshotsEdEsiti: [
				{ text: 'Codice cliccatore', value: 'codice_cliccatore'},
				{ text: 'Username cliccatore', value: 'username' },
				{ text: 'Squadra', value: 'team.nome' },
				{ text: 'Tempo', value: 'pivot.tempo_clickday' },
				// { text: 'Stato Screenshot', value: 'stato_screenshot', width: '410px' },
				{ text: 'File Screenshot', value: 'gestione_screenshot' },
				{ text: 'File Ricevuta', value: 'gestione_ricevuta' },
				{ text: 'Esito', value: 'pivot.esito_clickday' },
			],
			cliccatoriIscritti: [],
			cliccatoreIscrittoSelezionato: null,
			
			statiScreenshot: [
				'OK',
				'Errore',
				'Sbagliata',
				'Assente'
			],
			
			screenshot: null, // file di tipo immagine
			previewScreenshotDialog: false,
			previewScreenshotTitle: null,
			isLoadingBase64Screenshot: false,
			base64Screenshot: null,
			
			zoomOnHoverKey: 0,
			zoomEnabled: false,
			zoomScales: [1.2, 1.5, 2, 3],
			selectedZoomScale: 1.2,
			
			dialogModificaEsitoClickdayKey: 0,
			mostraDialogModificaEsitoClickday: false,
			datiModificaEsitoClickday: {
				idCliccatore: null,
				esitoClickday: null,
				tempoClickday: null,
				compensoFinale: null,
				noteCompenso: null,
				statoPagamentoCompenso: null,
				codiceCliccatore: null,
				nomeInDatiDiFatturazione: null,
				cognomeInDatiDiFatturazione: null
			},
			
			ricevutaPdf: null
		}
	},
	
	created() {
		if (this.computedAmIAdmin || this.computedAmIDeveloper) {
			this.getSquadre();
		}
		this.getIscritti();
	},
	
	computed: {
		totaleIscritti() {
			return this.cliccatoriIscritti.length;
		},
		totaleScreenshotsCaricati() {
			if (!this.isLoadingIscritti) {
				return this.cliccatoriIscritti.filter(cliccatoreIscritto => {
					return cliccatoreIscritto.pratica_cdm?.path_screenshot_invio != null;
				}).length
			}
		},
		totaleRicevuteCaricate() {
			if (!this.isLoadingIscritti) {
				return this.cliccatoriIscritti.filter(cliccatoreIscritto => {
					return cliccatoreIscritto.pratica_cdm?.path_ricevuta != null;
				}).length
			}
		}
	},
	
	methods: {
		getIscritti(idSquadra = null) {
			this.isLoadingIscritti = true;
			axios.get(`/bandi/${this.idBando}/iscritti`, {
				params: {
					team_id: idSquadra
				}
			})
				.then(response => {
					this.cliccatoriIscritti = response.data;
					this.cliccatoriIscritti.forEach(cliccatore => {
						this.$set(cliccatore, "isSelectingScreenshot", false); // reactive
						this.$set(cliccatore, "isUploadingScreenshot", false); // reactive
						this.$set(cliccatore, "screenshot", null); // reactive
						
						this.$set(cliccatore, "isSavingStatoScreenshot", null); // reactive
						
						this.$set(cliccatore, "isSelectingRicevuta", false); // reactive
						this.$set(cliccatore, "isUploadingRicevuta", false); // reactive
						this.$set(cliccatore, "isGettingRicevuta", false); // reactive
						this.$set(cliccatore, "ricevuta", null); // reactive
					})
				})
				.finally(() => {
					this.isLoadingIscritti = false;
				})
		},
		// GESTIONE SCREENSHOT
		uploadScreenshot(cliccatore) {
			cliccatore.isUploadingScreenshot = true;
			let formData = new FormData();
			formData.append('screenshot', cliccatore.screenshot);
			formData.append('cliccatore', JSON.stringify(cliccatore));
			formData.append('bando', JSON.stringify({
				id: this.idBando,
				nome: this.nomeBando
			}));
			axios.post('/bandi/upload-screenshot', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					cliccatore.pratica_cdm.path_screenshot_invio = response.data;
				})
				.finally(() => {
					cliccatore.isUploadingScreenshot = false;
				})
		},
		handleFileScreenshotImport(cliccatore) {
			cliccatore.isSelectingScreenshot = true;
			
			// this.cliccatoreIscrittoSelezionato = cliccatore;
			
			// After obtaining the focus when closing the FilePicker, return the button state to normal
			window.addEventListener('focus', () => {
				cliccatore.isSelectingScreenshot = false
			}, { once: true });
			
			// Trigger click on the FileInput
			this.$refs[`screenshotUploader${cliccatore.id}`].click();
		},
		onFileScreenshotChanged(e, cliccatore) {
			cliccatore.screenshot = e.target.files[0];
			// Do whatever you need with the file, like reading it with FileReader
			this.uploadScreenshot(cliccatore);
		},
		apriAnteprimaScreenshotDialog(cliccatore) {
			this.previewScreenshotDialog = true;
			this.previewScreenshotTitle = `Screenshot - ${cliccatore.codice_cliccatore || 'NESSUN CODICE CLICCATORE'}`
			this.getBase64Screenshot(cliccatore.pratica_cdm.path_screenshot_invio);
		},
		getBase64Screenshot(path) {
			this.isLoadingBase64Screenshot = true;
			return axios.post('/storage/get-base-64-file', {
				path: path,
				disk: 's3_cdm'
			})
				.then(response => {
					this.base64Screenshot = response.data;
				})
				.finally(() => {
					this.isLoadingBase64Screenshot = false;
				})
		},
		salvaStatoScreenshot(cliccatore) {
			cliccatore.isSavingStatoScreenshot = true;
			axios.post('/bandi/stato-screenshot', {
				cliccatore_id: cliccatore.id,
				id_bando: this.idBando,
				stato_screenshot: cliccatore.pivot.stato_screenshot,
			})
				.finally(() => {
					cliccatore.isSavingStatoScreenshot = false;
				})
		},
		// GESTIONE RICEVUTA
		uploadRicevuta(cliccatore) {
			cliccatore.isUploadingRicevuta = true;
			let formData = new FormData();
			formData.append('ricevuta', cliccatore.ricevuta);
			formData.append('cliccatore', JSON.stringify(cliccatore));
			formData.append('bando', JSON.stringify({
				id: this.idBando,
				nome: this.nomeBando
			}));
			axios.post('/bandi/upload-ricevuta', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					cliccatore.pratica_cdm.path_ricevuta = response.data;
				})
				.finally(() => {
					cliccatore.isUploadingRicevuta = false;
				})
		},
		handleFileRicevutaImport(cliccatore) {
			cliccatore.isSelectingRicevuta = true;
			
			// After obtaining the focus when closing the FilePicker, return the button state to normal
			window.addEventListener('focus', () => {
				cliccatore.isSelectingRicevuta = false
			}, { once: true });
			
			// Trigger click on the FileInput
			this.$refs[`ricevutaUploader${cliccatore.id}`].click();
		},
		onFileRicevutaChanged(e, cliccatore) {
			cliccatore.ricevuta = e.target.files[0];
			// Do whatever you need with the file, like reading it with FileReader
			this.uploadRicevuta(cliccatore);
		},
		apriRicevutaInUnaNuovaSchedaDelBrowser(cliccatore) {
			cliccatore.isGettingRicevuta = true;
			axios.post('/bandi/get-ricevuta', {
				path_ricevuta: cliccatore.pratica_cdm.path_ricevuta
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// this.ricevutaPdf = response.data;
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					cliccatore.isGettingRicevuta = false;
				})
		},
		//
		getSquadre: function () {
			this.isLoadingSquadre = true;
			return axios.get("/teams")
				.then(response => {
					this.squadre = response.data.data;
					// this.squadre.unshift({
					// 	id: 0,
					// 	nome: "Squadra Principale"
					// });
				})
				.finally(() => {
					this.isLoadingSquadre = false;
				});
		},
		apriDialogEsitoClickday(cliccatore) {
			console.log(cliccatore)
			this.dialogModificaEsitoClickdayKey++;
			
			this.datiModificaEsitoClickday = {
				idCliccatore: cliccatore.id,
				esitoClickday: cliccatore.pivot.esito_clickday,
				tempoClickday: cliccatore.pivot.tempo_clickday,
				compensoFinalePersonalizzatoEsitiProvvisori: cliccatore.pivot.compenso_finale,
				compensoFinalePersonalizzatoEsitiDefinitivi: cliccatore.pivot.compenso_finale_personalizzato_esiti_definitivi,
				statoPagamentoCompenso: cliccatore.pivot.stato_pagamento,
				noteCompenso: cliccatore.pivot.note_compenso,
				codiceCliccatore: cliccatore.codice_cliccatore,
				nomeInDatiDiFatturazione: cliccatore.pivot.nome,
				cognomeInDatiDiFatturazione: cliccatore.pivot.cognome,
			}
			
			this.mostraDialogModificaEsitoClickday = true;
		},
	}
}
</script>